
<div class="left-navbar">
    <a class="navbar-button" [routerLink]="['/']">
        <img class="logo" src='assets/images/pikitLogo.png'/>
    </a>
</div>

<div class="searchBar" id="searchBar">
    <mat-icon>search</mat-icon>
    <div class="autocomplete" style="width:100%;">
        <input type="text" [(ngModel)]="searchText" placeholder="Search Pikit" (ngModelChange)="updateSearch()"/>
        <!-- <input id="myInput" type="text" name="myCountry" placeholder="Country"> -->
        <div id="autocomplete-list" class="autocomplete-items">
            <div *ngFor="let item of autoCompleteItems" (click)="goToUserProfile(item)">
                <strong>{{item.substr(0,searchText.length)}}</strong>{{item.substr(searchText.length)}}
            </div>
        </div>
    </div>
</div>

<div class="right-navbar">
    <div *ngIf="!userSignedIn">
        <ul>
            <li>
                <a routerLink="/signup" class="signInSignOut">SIGN UP</a>
            </li>
            <li>
                <a routerLink="/signin" class="signInSignOut">SIGN IN</a>
            </li>
        </ul>
    </div>
    
    <div *ngIf="userSignedIn">
        <ul>
            <li>

                <a (click)="viewProfile()">
                    <mat-icon class="profileIcon">person_outline</mat-icon>
                </a>
                
            </li>
            <li>
                <a (click)="logout()" class="signInSignOut">SIGN OUT</a>
            </li>
        </ul>
        <!-- <a class="navbar-button"  (click)="viewProfile()">My Profile</a>
        <a class="navbar-button"  (click)="logout()">Sign Out</a> -->
    </div>
</div>

  
  
  <!-- 
  Copyright Google LLC. All Rights Reserved.
  Use of this source code is governed by an MIT-style license that
  can be found in the LICENSE file at https://angular.io/license
  -->
  